import {
    AiProvider,
    ButtonAttach,
    ButtonChooseTemplate,
    ButtonMain,
    ButtonPromptHistory,
    Chat,
} from '@/biz/ai'

import {useAi} from '@/biz/ai/chat'
import useCurrentProject from '@/biz/useCurrentProject.mjs'
import {useDrawerContext} from '../MainPage.jsx'

const AiChatCommon = () => {
    const [project] = useCurrentProject()
    const {pkid: prjId, sVer} = project
    const ai = useAi({biz: {}, prjId, scene: 'DEFAULT', sVer})

    const tools = [
        <>
            <ButtonChooseTemplate />
        </>,

        <>
            <ButtonPromptHistory />
            <ButtonAttach />
            <ButtonMain />
        </>
    ]

    return (
        <AiProvider value={ai}>
            <Chat
                style={{height: '100%'}}
                tools={tools}
            />
        </AiProvider>
    )
}

export default () => {
    const setDrawer = useDrawerContext()
    const title = '通用AI助手'

    const onClick = () => setDrawer({
        bodyStyle: {padding: 0},
        content: <AiChatCommon />,
        title,
    })

    return {title, onClick}
}
